module.exports = "<div class=\"play-wrapper\" data-poster>\n  <span class=\"poster-icon play\" data-poster />\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/plugins/poster/public/poster.html
 ** module id = 146
 ** module chunks = 0
 **/